import { jsx as _jsx, jsxs as _jsxs } from "preact/jsx-runtime";
import { render } from "preact";
import { useEffect, useRef, useState } from "preact/hooks";
import LightboxVimeoPlayer from "./vimeoPlayer";
import LightboxYouTubePlayer from "./youtubePlayer";
function isValidDataset(element, requiredAttributes) {
    let isValid = true;
    requiredAttributes.forEach((attr) => {
        if (!(attr in element.dataset)) {
            isValid = false;
        }
    });
    return isValid && element.dataset;
}
const Lightbox = (props) => {
    const [playerContent, setPlayerContent] = useState();
    const backdropRef = useRef(null);
    const handleClose = () => {
        props.onDestroy();
    };
    const handleKeyDown = (event) => {
        if (event.key === "Escape") {
            handleClose();
        }
    };
    useEffect(() => {
        var _a;
        switch (props.type) {
            case "vimeo":
                if (typeof props.url !== "string") {
                    console.error("Vimeo url must be a string");
                    return;
                }
                setPlayerContent(_jsx(LightboxVimeoPlayer, { url: props.url }));
                break;
            case "youtube":
                if (typeof props.url !== "string") {
                    console.error("YouTube url must be a string");
                    return;
                }
                setPlayerContent(_jsx(LightboxYouTubePlayer, { url: props.url }));
                break;
            default:
                break;
        }
        const keyDownListener = (event) => {
            if (event.key === "Escape") {
                handleClose();
            }
        };
        const clickListener = () => {
            handleClose();
        };
        window.addEventListener("keydown", keyDownListener);
        (_a = backdropRef.current) === null || _a === void 0 ? void 0 : _a.addEventListener("click", clickListener);
        return () => {
            var _a;
            window.removeEventListener("keydown", keyDownListener);
            (_a = backdropRef.current) === null || _a === void 0 ? void 0 : _a.removeEventListener("click", clickListener);
        };
    }, []);
    return (_jsxs("div", { class: "soul-lightbox", children: [_jsx("div", { className: "soul-lightbox__backdrop", ref: backdropRef }), _jsxs("div", { className: "soul-lightbox__wrapper", children: [_jsx("button", { class: "soul-lightbox__close-button", onClick: handleClose, children: "Close" }), playerContent] })] }));
};
function initLightboxTarget(target) {
    if (!target) {
        console.error("No target provided");
        return;
    }
    const renderTarget = document.querySelector(".soul-lightbox-render-target");
    if (!renderTarget) {
        console.error("Render target not found");
        return;
    }
    const requiredAttributes = ["lightboxType", "lightboxUrl"];
    const targetData = isValidDataset(target, requiredAttributes);
    if (!targetData) {
        console.error("Not all required attributes are set");
        return;
    }
    target.addEventListener("click", (event) => {
        event.preventDefault();
        if (target.nodeName === "VIDEO") {
            target.pause();
        }
        const onDestroy = () => {
            if (target.nodeName === "VIDEO") {
                target.play();
            }
            // Clear the render target completely
            while (renderTarget.firstChild) {
                renderTarget.removeChild(renderTarget.firstChild);
            }
            renderTarget.classList.remove("active");
        };
        // Clear any existing content first
        while (renderTarget.firstChild) {
            renderTarget.removeChild(renderTarget.firstChild);
        }
        // Add a unique key to force remounting instead of updating
        render(_jsx(Lightbox, { target: target, type: targetData.lightboxType, url: targetData.lightboxUrl, onDestroy: onDestroy }, Date.now()), renderTarget);
        renderTarget.classList.add("active");
    });
}
function initAllLightboxTargets() {
    if (window.lightboxInitialized)
        return;
    window.lightboxInitialized = true;
    const lightboxTargets = document.querySelectorAll("[data-lightbox-target]");
    lightboxTargets.forEach(initLightboxTarget);
}
export default initAllLightboxTargets;
export { initLightboxTarget, Lightbox };
